module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKAgMAAADJO5Z1AAAAAXNSR0IB2cksfwAAAAxQTFRFAAAAAAAAAAAAAAAANek3lgAAAAR0Uk5TAGD/oL628yAAAAAySURBVHicFckxEQAgDMDAsCCCQ2FxVjogAWmE5YeEyMzN0KLroemFMOMo7WYcZlgfJjyxVRHMpj0V9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/select-arrow@2x.png
// module id = 906
// module chunks = 0